export const locales = [
  'af-AF',
  'de-DE',
  'en-GB',
  'en-US',
  'en-ZA',
  'es-ES',
  'fr-FR',
  'ja-JP',
  'fr-BE',
  'hu-HU',
  'id-ID',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'ru-RU',
  'sv-SE',
  'zh-Hans',
  'ar-SA',
] as const;

export const i18nNamespaces = {
  global: [
    'email',
    'general',
    'login',
    'language',
    'navigation',
    'notifications',
    'candidate_profile',
    'candidate_account',
    'error',
    'privacy',
    'accessibility',
    'mfa',
  ],
  profile: [
    'brain_summary',
    'profile',
    'candidate_account',
    'candidate_profile',
    'career_paths',
    'data_demographics',
    'data_jobs',
    'drive_dimensions',
    'drive_report',
    'drive_summary',
    'feedback',
    'remote_score',
    'shape_summary',
    'talent_cloud',
    'talent_tags',
    'recruiter_network',
    'privacy',
    'voice',
    'voice_summary',
    'voice_report',
    'skills',
    'tools',
  ],
  career: ['predict_success', 'po'],
  network: [
    'manage_network',
    'data_jobs',
    'jobs',
    'recruiter_network',
    'candidate_profile',
    'candidate_account',
    'privacy',
  ],
  myCompany: ['competency_framework', 'drive_dimensions', 'shape_dimensions'],
  jobs: ['jobs', 'data_jobs', 'drive_dimensions'],
  settings: ['candidate_account', 'oauth', 'account_phone_update', 'reset_password', 'mfa'],
  poleEmploi: ['pole_emploi'],
  shareProfile: ['candidate_account'],
} as const;
